import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { concatLatestFrom } from '@ngrx/operators';
import { lessonActions } from '@app/store/lesson/actions/lesson.actions';
import { lessonsActions } from '../actions/lessons.actions';
import { selectLastParams } from '../selectors/lessons.selector';

@Injectable()
export class LessonLessonsBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    refreshOnMutation$ = createEffect(() => {
        return this.actions.pipe(
            ofType(lessonActions.createLessonSuccess, lessonActions.updateLessonSuccess, lessonActions.deleteLessonSuccess),
            concatLatestFrom(() => this.store.select(selectLastParams)),
            map(([, lastParams]) => lessonsActions.getLessons({ value: lastParams })),
        );
    });
}
